<a *ngIf="route; else regularLink" [attr.title]="title && (title | translate)"
   class="anchor" [class.mod-icon]="icon" [class.button]="isButton" [ngClass]="mergedLinkClass" [routerLink]="route">
  <ng-container *ngTemplateOutlet="linkContents"></ng-container>
</a>

<ng-template #regularLink>
  <a *ngIf="link; else dummyLink" class="anchor" [class.mod-icon]="icon" [attr.title]="title && (title | translate)" [class.button]="isButton" [ngClass]="linkClass" [href]="link">
    <ng-container *ngTemplateOutlet="linkContents"></ng-container>
  </a>
</ng-template>

<ng-template #dummyLink>
  <a class="anchor" [class.mod-icon]="icon" [class.button]="isButton" [attr.title]="title && (title | translate)" [ngClass]="linkClass">
    <ng-container *ngTemplateOutlet="linkContents"></ng-container>
  </a>
</ng-template>


<ng-template #linkContents>
  <cp-icon *ngIf="icon; else linkLabel" class="link-icon" [icon]="icon" [colorClass]="colorClass">
  </cp-icon>
</ng-template>

<ng-template #linkLabel>
  {{label | translate}}
</ng-template>
